import * as _ from 'lodash';

import { ContentItemModality, ContentItemModel } from '@models';

class ContentItemService {
  constructor() {}

  determineModality(contentItems: ContentItemModel[]): ContentItemModality | null {
    let hasText = false;
    let hasMedia = false;

    contentItems.forEach((item) => {
      if (item.text && item.text.trim() !== '') {
        hasText = true;
      }
      if (item.mediaitem) {
        hasMedia = true;
      }
    });

    if (hasText) {
      return ContentItemModality.TEXT;
    } else if (hasMedia) {
      return ContentItemModality.MEDIA;
    } else {
      return null;
    }
  }

  isDefaultModalityFixed(contentItems: ContentItemModel[]): boolean {
    return contentItems.some((item) => (item.text && item.text.trim() !== '') || item.mediaitem);
  }
}

const findByCid = (value: unknown, cid: string): any => {
  if (Array.isArray(value)) {
    for (const entry of value) {
      const found = findByCid(entry, cid);
      if (found) return found;
    }
    return null;
  }
  if (value === null || typeof value !== 'object') return null;
  if ((value as any).cid === cid) return value;
  for (const nested of Object.values(value)) {
    const found = findByCid(nested, cid);
    if (found) return found;
  }
  return null;
};

// A finished upload can outlive the card it belonged to, so a missing holder is a normal outcome.
const setMediaitemIdAt = <T>(content: T, contentItemCid: string | null, mediaitemId: number): T => {
  const next = _.cloneDeep(content);
  const holder: any = contentItemCid ? findByCid(next, contentItemCid) : next;
  if (!holder?.item) return content;
  holder.item.mediaitemId = mediaitemId;
  holder.item.mediaitem = null;
  return next;
};

export { ContentItemService, setMediaitemIdAt };
